import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { initErrorBuffer } from "./components/BugReporter/hooks/useErrorBuffer";
import { initCapacitor } from "./services/capacitorInit";
import { initKeyboardViewport } from "./services/keyboardViewport";

if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

// Capture console.error / unhandledrejection so bug reports can attach recent client errors.
initErrorBuffer();

// Native (iOS/Android) bootstrap — no-op on web. Kicked off before render so
// the StatusBar/Keyboard/back-button/splash handlers are armed at first paint.
initCapacitor();
// Keep the composer above the on-screen keyboard in the native app (no-op on
// web / desktop). Uses visualViewport → --app-vh, read by the layout.
initKeyboardViewport();

ReactDOM.render(
  //<React.StrictMode>
  <App />
  //</React.StrictMode>
  ,
  document.getElementById('root'),
  () => {
    window.finishProgress();
  }
);
